import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "45%",
  },
  cashlessPaper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  table: {
    minWidth: 650,
    overflowX: "scroll",
  },
  editModal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  EditPaper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  importPaper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  divBox: {
    border: "2px solid #969696",
    padding: "10px",
  },
  previewImgContainer: {

    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight:"25rem",
    minWidth: "20rem"
  },
  previewImg: {
    maxWidth: "95%",
    maxHeight: "67vh",
    margin: "1rem",
  },
  previewImgCloseBtnWrapper:{
    paddingBottom: "1rem",
    width:"100%",
    height:"100%",
    display:"flex",
    justifyContent:"center",
    alignItems:"center"
  },
  previewBtn: {
    paddingLeft: '0.4rem',
    marginTop: "0.8rem"
  },
  dialogHeading: {
    backgroundColor: theme.palette.primary.main,
    color: "white"
  },
  closeIconWrapper: {
    position: "absolute",
    top: 12,
    right: 8
  },
  closeIcon: {
    color: "white"
  },
  dialogCloseIcon: {
    color: "white"
  },
  receiptModalWrapper: {
    width: "100% !important",
    margin: "0.3rem 0 !important",
  },
  fileReaderWrapper: {
    display: "flex",
    flexWrap: "wrap"
  },
  fileDetailWrapper: {
    marginLeft: "0.8rem",
    display: "flex",
    alignItems: "center",
  },
  deleteIcon: {
    border: "0.06rem solid",
    borderRadius: "0.2rem",
    color: "#f5365c"
  },
  previewIconBtn: {
    border: '0.01rem solid #1976d2',
    color: '#1976d2',
    borderRadius: "0.2rem",
    marginLeft: "0.3rem"
  },
  actionIconBtn: {
    padding: "0.3rem !important"
  },
  uploadWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap"
  },
  fileActionWrapper: {
    display: "flex",
    alignItems: "center"
  },
  fileName: {
    margin: "0 0.3rem"
  },
  checkBox_wrapper: {
    whiteSpace: "nowrap"
  },
  input: {
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
  // Import Results Styles
  importResultsContainer: {
    padding: '16px',
    borderRadius: '4px',
    marginTop: '16px',
  },
  importResultsContainerSuccess: {
    border: '1px solid #4caf50',
    backgroundColor: '#f9f9f9',
  },
  importResultsContainerError: {
    border: '1px solid #f44336',
    backgroundColor: '#fff3f3',
  },
  importResultsTitle: {
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'center',
  },
  importResultsIcon: {
    marginRight: '8px',
  },
  importResultsIconSuccess: {
    color: '#4caf50',
  },
  importResultsIconWarning: {
    color: '#ff9800',
  },
  importResultsIconError: {
    color: '#f44336',
  },
  importMessageContainer: {
    padding: '8px 12px',
    borderRadius: '4px',
    marginBottom: '12px',
  },
  importMessageContainerSuccess: {
    backgroundColor: '#e8f5e8',
    border: '1px solid #c8e6c9',
  },
  importMessageContainerError: {
    backgroundColor: '#ffebee',
    border: '1px solid #ffcdd2',
  },
  importMessageText: {
    fontWeight: 'bold',
  },
  importMessageTextSuccess: {
    color: '#2e7d32',
  },
  importMessageTextError: {
    color: '#d32f2f',
  },
  importStatistics: {
    marginBottom: '12px',
  },
  importStatisticsSuccess: {
    color: '#2e7d32',
  },
  importStatisticsError: {
    color: '#d32f2f',
    fontWeight: 'bold',
  },
  importErrorDetails: {
    padding: '12px',
    backgroundColor: '#ffebee',
    borderRadius: '4px',
    border: '1px solid #ffcdd2',
  },
  importErrorDetailsTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
    color: '#d32f2f',
    fontWeight: 'bold',
  },
  importErrorList: {
    margin: '0',
    paddingLeft: '20px',
  },
  importErrorListItem: {
    color: '#d32f2f',
    marginBottom: '4px',
    fontSize: '14px',
  },
  submitButtonContainer: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end',
  },
  colorPickerSwatch: {
    width: '1.75rem',
    height: '1.75rem',
    padding: 0,
    border: '1px solid #c0c0c0',
    borderRadius: '0.25rem',
    background: 'transparent',
    cursor: 'pointer',
    '&::-webkit-color-swatch-wrapper': {
      padding: 0,
    },
    '&::-webkit-color-swatch': {
      border: 'none',
      borderRadius: '0.2rem',
    },
    '&::-moz-color-swatch': {
      border: 'none',
      borderRadius: '0.2rem',
    },
  },
  colorSectionTitle: {
    margin: '0 0 0.5rem 0',
    fontSize: '1rem',
    fontWeight: 600,
  },
}));

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

export function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
    maxHeight: "70vh",
    overflow: "scroll",
    width: "55%",
  };
}

export function getImportModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}
